import { Routes, Route/*, Link*/ } from 'react-router-dom';
import './App.css'




import { Home } from './pages/Home.tsx';
import { NotFound } from './pages/NotFond.tsx';
import { DrawerRouterContainer } from './pages/DrawerRouterContainer.tsx'
import { UsersPage } from './pages/UsersPage.tsx';
import { ContinentsPage } from './pages/locations/ContinentsPage.tsx';
import { NationalitiesPage } from './pages/locations/NationalitiesPage.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
function App() {

  return (
    <DrawerRouterContainer>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/users' element={<UsersPage/>}/>
        <Route path='/continents' element={<ContinentsPage/>}/>
        <Route path='/nationalities' element={<NationalitiesPage/>}/>
        <Route path='/login' element={<LoginPage/>}/>
        <Route path='*' element={<NotFound/>}/>
      </Routes>
    </DrawerRouterContainer>
  )
}

export default App
